define('model/GdprReportModuleModel',['require','lib/validator/ValidatorEmail','lib/validator/ValidatorPhone','lib/validator/ValidatorNotEmpty','backbone','Config','lib/model/BaseModel'],function (require) {
    var ValidatorEmail = require('lib/validator/ValidatorEmail');
    var ValidatorPhone = require('lib/validator/ValidatorPhone');
    var ValidatorNotEmpty = require('lib/validator/ValidatorNotEmpty');
	var Backbone = require('backbone');
    var Config = require('Config');
    var BaseModel = require('lib/model/BaseModel');
	/**
	 * GdprReportModuleModel
	 * 
	 * @class MenuModel
	 */
	return BaseModel.extend({

        url: '/v2/gdpr-report/info-by-email-phone',
		
		defaults: {
			//plugins: {},
            result : false,
			is_form_active : false,
            email : null,
            phone : null,
            is_client_logged : false
		},

		initialize: function () {
            var plugins = {};
            _.each(Config.getInstance().getOption('plugins'), function (plugin, pluginName) {
                plugins[pluginName] = parseInt(plugin.is_active);
            });

            //this.set('plugins', plugins);

            this.validators = {
               // email : [new ValidatorNotEmpty(), new ValidatorEmail()],
            };
		},

        validate: function () {
            var errors = BaseModel.prototype.validate.apply(this, arguments);
            return errors;
        },

        logout: function () {
            this.set({
                'is_client_logged': null,
                'code': null,
                'email': null,
                'phone': null,
                'type': null
            });
        }
	
	}, {

	    instance: null,

        getInstance: function () {
	        if (!this.instance) {
	            this.instance = new this();
            }
            return this.instance;
        }

    });

});
